// const devConsoleEnabled = developOptions?.SHOW_DEV_CONSOLE_LOG; //TODO ==> find why this method is not working
const devConsoleEnabled = process.env.NODE_ENV === "development";

export function devConsoleLog(...props) {
  if (devConsoleEnabled) console.log("⋮", ...props);
}

export function devConsoleWarn(...props) {
  if (devConsoleEnabled)
    // console.log("%cWARN:", "color: orange; font-size: small", ...props)
    console.warn("⋮", ...props);
}
